(function () {
  function parseEndDate(str) {
    var parts = str.trim().split(/\s+/);
    var datePart = parts[0];
    var timePart = parts[1];
    if (!datePart) return null;
    var dateBits = datePart.split('-');
    var y = parseInt(dateBits[0], 10);
    var m = parseInt(dateBits[1], 10);
    var d = parseInt(dateBits[2], 10);
    var hour = 23, min = 59, sec = 59;
    if (timePart) {
      var t = timePart.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
      if (t) {
        hour = parseInt(t[1], 10);
        min = parseInt(t[2], 10);
        sec = t[3] != null ? parseInt(t[3], 10) : 0;
      }
    }
    return new Date(y, m - 1, d, hour, min, sec, 0);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown(countdownEl) {
    var endStr = countdownEl.getAttribute('data-end-datetime');
    if (!endStr) return;
    var endDate = parseEndDate(endStr);
    if (!endDate || isNaN(endDate.getTime())) return;
    var daysEl = countdownEl.querySelector('[data-days]');
    var hoursEl = countdownEl.querySelector('[data-hours]');
    var minsEl = countdownEl.querySelector('[data-mins]');
    var secsEl = countdownEl.querySelector('[data-secs]');

    function update() {
      var now = new Date();
      var diff = endDate.getTime() - now.getTime();
      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '0';
        if (hoursEl) hoursEl.textContent = '0';
        if (minsEl) minsEl.textContent = '0';
        if (secsEl) secsEl.textContent = '0';
        return;
      }
      var days = Math.floor(diff / 86400000);
      diff -= days * 86400000;
      var hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      var mins = Math.floor(diff / 60000);
      diff -= mins * 60000;
      var secs = Math.floor(diff / 1000);
      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    update();
    setInterval(update, 1000);
  }

  function run() {
    document.querySelectorAll('.promo-timer__countdown[data-end-datetime]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
